import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from "react";
import PriceLabel from "../../commons/priceLabel";
import smoothscroll from "smoothscroll-polyfill";
import { formatPrice } from "../../../utils/formatPrice";
const ReservationStickyButton = ({ myData, formData, rate, setIsOpen, isOpen, t, labelFunction }) => {
    var _a, _b, _c, _d, _e;
    const url = new URLSearchParams(window.location.search);
    let paymentOnDestination = false;
    if (url.get("paymentOnDestination") === "true") {
        paymentOnDestination = true;
    }
    const price = formatPrice((_e = (_d = (_c = (_b = (_a = myData.pricesDetail) === null || _a === void 0 ? void 0 : _a.currency) === null || _b === void 0 ? void 0 : _b[2]) === null || _c === void 0 ? void 0 : _c.total) === null || _d === void 0 ? void 0 : _d.amount) !== null && _e !== void 0 ? _e : 0, formData.currency);
    const [isActive, setIsActive] = useState(false);
    smoothscroll.polyfill();
    const handleTouchClick = () => {
        setIsActive(!isActive);
    };
    // const moveButton = () => {
    //   const observer = new MutationObserver((mutationsList) => {
    //       mutationsList.forEach((mutation) => {
    //           if (mutation.type === "childList") {
    //               const buttonElement = document.querySelector<HTMLElement>(".transaction__button--mobile");
    //               if (buttonElement) {
    //                   document.body.appendChild(buttonElement);
    //
    //                   observer.disconnect(); // Detener el observer después de mover el botón
    //               }
    //           }
    //       });
    //   });
    //   // Observar cambios en todo el <body>
    //   observer.observe(document.body, { childList: true, subtree: true });
    // };
    return (_jsx(_Fragment, { children: !isOpen &&
            _jsxs("div", { className: "reservation-float", children: [_jsxs("div", { className: "reservation-float__content", children: [_jsx(PriceLabel, { price: price, currency: formData.currency, country: sessionStorage.getItem("country"), days: formData.totalDays, paymentOnDestination: paymentOnDestination }), _jsx("span", { className: "text-small", children: t("final_price_1") + " " + formData.totalDays + " " + t("days") })] }), _jsx("div", { className: "reservation-float__button", children: _jsx("button", { className: "button-primary button--bg-gradient-primary264g button--rounded", onTouchStart: handleTouchClick, onTouchEnd: handleTouchClick, onClick: () => {
                                labelFunction();
                                // moveButton();
                            }, children: t("btn-booking") }) })] }) }));
};
export default ReservationStickyButton;
